import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import createDomPurify from 'dompurify';
import { CONSTANTS, routes } from '../Helpers/Configuration';
var urlParser = require('url');

const { defaultSanitizeOptions } = CONSTANTS;
const domPurify = createDomPurify(window);
const wrap = (val) =>{ return '"' + val + '"';};

//hrefs without a protocol can link the user to something relative like <APe>/{href url}
//    so this regex matches on the href tags so code can inject a protocol to any url
const regEx = new RegExp('hrefs*=s*"([^"]*)"', 'ig');

const HtmlFormattedMessage = props => {
    const intl = useIntl();
    const {
        descriptor,
        htmlString,
        sanitizeOptions,
        stripHeadingTags,
        normalizeSpaces
    } = props;
    function replaceAllPlaceholders(decodedHtml) {
        decodedHtml = decodedHtml || '';

        //Swap instaces of {RetrievalLink} to actual URL
        return decodedHtml.replaceAll(CONSTANTS.contentPlaceholders.appRetreivalLink, document.location.origin + routes.retrieval);
    }
    const html = useMemo(() => {
        let decodedHtml = decodeURI(descriptor ? intl.formatMessage(descriptor) : (htmlString || ''));
        try {
            decodedHtml = replaceAllPlaceholders(decodedHtml);

            let match;
            //For each match on href="url" ensure a protocol exists and then replace the href tag's property
            while((match = regEx.exec(decodedHtml)) !== null) {
                const rawUrl = match[1];
                const url = urlParser.parse(rawUrl);
                decodedHtml = decodedHtml.replace(wrap(rawUrl), wrap((url.protocol ? '' : 'https://') + url.href));
            }
        }
        catch {
            //Do nothing, return html as it
        }

        // If requested, convert heading elements into neutral paragraphs so
        // instructional text does not appear as real document headings.
        if (stripHeadingTags) {
            for (let level = 1; level <= 6; level++) {
                const openTag = new RegExp(`<\\s*h${level}([^>]*)>`, 'gi');
                const closeTag = new RegExp(`<\\s*/\\s*h${level}\\s*>`, 'gi');
                decodedHtml = decodedHtml.replace(openTag, (full, attrs = '') => `<p data-original-heading="h${level}"${attrs}>`);
                decodedHtml = decodedHtml.replace(closeTag, '</p>');
            }
        }

        let sanitized = domPurify.sanitize(decodedHtml, {
            ...defaultSanitizeOptions, 
            ...sanitizeOptions,
            ADD_ATTR: ['target', 'rel', 'data-original-heading'] // allow data-original-heading
        });

        if (normalizeSpaces) {
            sanitized = sanitized.replace(/&nbsp;/g, ' ');
        }

        return sanitized;
    }, [descriptor, htmlString, sanitizeOptions, stripHeadingTags, normalizeSpaces]);

    return (<span dangerouslySetInnerHTML={{ __html: html }}></span>);
};

export default HtmlFormattedMessage;